module.exports = __webpack_public_path__ + "static/media/a-5-a.eae9d54f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-5-a.jpg
// module id = 462
// module chunks = 33